import { createSelector } from '@ngrx/store';

import * as fromReducer from '@flight-results/store/reducers/ui/showed-details.reducer';
import { flightResultsRootSelector } from '@flight-results/store/selectors/flight-results-root.selector';
import { FlightResultsModuleState, UiFlightsState } from '@flight-results/store/state/flight-results-module.state';

export const getUiFlightsState = createSelector(
  flightResultsRootSelector,
  (state: FlightResultsModuleState) => state?.ui
);

export const getShowedState = createSelector(getUiFlightsState, (state: UiFlightsState) => state.showedDetails);
export const showedDetailsSelector = createSelector(getShowedState, fromReducer.selectAll);
